import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Carousel from 'components/UI/Carousel';
import Card from 'components/Card';
import CmsLink from 'components/UI/CmsLink';
import { USER_LEVEL } from 'constants/global';
import isGestopagoCard from 'utils/isGestopagoCard';
import './styles.scss';

const CardsCarousel = (props) => {
  const {
    className = '',
    title = '',
    link = {
      link: '',
      archor: '',
    },
    cards = [],
  } = props;

  const { user } = useSelector((state) => state.session);
  const isComplete = user?.level === USER_LEVEL.COMPLETE;
  const visibleCards = cards.filter((card) => isComplete || !isGestopagoCard(card?.link));

  if (!visibleCards.length) {
    return null;
  }

  const slides = visibleCards.map((card) => (
    card.content ? (
      <div key={`card-${card.id}`}>{card.content}</div>
    ) : (
      <Card key={`card-${card.id}`} {...card} />
    )
  ));

  return (
    <div className={`cards-carousel ${className}`}>
      <div className='flex justify-between items-center mb-4 carousel-title'>
        {title && (<h2 className='m-0'>{title}</h2>)}
        {link?.archor && (
          <CmsLink to={link.link} className='font-bold' external={link.external}>
            {link?.archor}
          </CmsLink>
        )}
      </div>
      {slides.length > 1 ? (
        <Carousel
          slides={slides}
          showNext
          breakpoints={{
            768: { slidesPerView: 2, spaceBetween: 16 },
          }}
        />
      ) : (
        <div className='cards-carousel__single'>{slides[0]}</div>
      )}
    </div>
  );
};

CardsCarousel.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.object,
  cards: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    content: PropTypes.node,
  })).isRequired,
};

export default CardsCarousel;
